import { basketApiUrl } from 'store/common/constants/basket';
export const redirectToBasket = () => {
  window.location.href = '/basket/';
};

export const composeDeleteBasketUrl = (basketId: string, itemId: string) =>
  `${window.location.origin}/${basketApiUrl as string}/${basketId}/item/${itemId}`;
